import type { RequestRatingDetailResponse } from "@nlc/shared-types";

import { useState } from "react";

import { Button } from "@/components/button";
import { dateFormatter } from "@/utils/dateFormatter";

import { RatingUser } from "./RatingUser";

type Edit = RequestRatingDetailResponse["edits"][number];

export function RatingEditHistory({ edits }: { edits: Edit[] }) {
  const [isOpen, setIsOpen] = useState(false);

  if (edits.length === 0) return null;

  return (
    <div className="flex flex-col gap-sm border-t border-border-secondary pt-md">
      <Button
        className="self-start"
        onPress={() => setIsOpen(!isOpen)}
        size="sm"
        variant="tertiary"
      >
        {isOpen ? "Hide" : "Show"} edit history ({edits.length})
      </Button>

      {isOpen && (
        <ul className="flex flex-col gap-md">
          {edits.map((edit, index) => (
            <li
              className="flex flex-col gap-xs rounded-lg bg-bg-secondary p-md text-sm text-text-tertiary"
              key={`${edit.editedAt}-${index}`}
            >
              <p className="flex flex-wrap items-center gap-xs font-medium text-text-primary">
                <RatingUser
                  avatar={edit.editedBy?.avatar}
                  fallback="A teammate"
                  name={edit.editedBy?.name ?? null}
                />
                <span>- edited {dateFormatter(edit.editedAt)}</span>
              </p>

              <p>
                Stars: design {edit.previousDesign}, team {edit.previousTeam},
                platform {edit.previousPlatform}
              </p>

              <p className="flex flex-wrap items-center gap-xs">
                Assignee:{" "}
                <RatingUser
                  avatar={edit.previousDesigner?.avatar}
                  name={edit.previousDesigner?.name ?? null}
                />
              </p>

              {edit.previousChips.length > 0 && (
                <p>
                  Chips:{" "}
                  {edit.previousChips.map((chip) => chip.chip).join(", ")}
                </p>
              )}

              {edit.previousComment && <p>Comment: {edit.previousComment}</p>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
